(function(){
  var root = document.querySelector('.kmso-calm');
  if(!root) return;
  var fill=document.getElementById('fill'),
      phase=document.getElementById('phase'),
      count=document.getElementById('count'),
      desc=document.getElementById('desc'),
      go=document.getElementById('go'),
      running=false, timers=[];
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clearTimers(){ timers.forEach(clearTimeout); timers=[]; }
  function at(ms,fn){ timers.push(setTimeout(fn,ms)); }
  function tick(sec, el){
    for(var i=0;i<sec;i++){
      (function(n){ at(n*1000,function(){ el.textContent=(sec-n)+' seconds'; }); })(i);
    }
  }
  if(go){
    go.addEventListener('click', function(){
      if(running) return;
      if(reduced){
        phase.textContent='Exhale for 8';
        count.textContent='Motion reduced';
        desc.textContent='Breathe in through your nose for four counts, hold for seven, then let the breath out slowly for eight. Five rounds is the full practice.';
        return;
      }
      running=true; go.textContent='Breathing…'; go.style.opacity='.55'; clearTimers();
      fill.className='pacer-fill';
      phase.textContent='Inhale';
      desc.textContent='Through your nose. Let it be unhurried.';
      fill.style.height='100%';
      tick(4,count);
      at(4000,function(){
        fill.className='pacer-fill hold';
        phase.textContent='Hold';
        desc.textContent='Your body starts to settle here.';
        tick(7,count);
      });
      at(11000,function(){
        fill.className='pacer-fill exhale';
        fill.style.height='6%';
        phase.textContent='Exhale';
        desc.textContent='Slow and complete. This is the part that does the work, and the part the Shift paces for you.';
        tick(8,count);
      });
      at(19000,function(){
        phase.textContent='That was one.';
        count.textContent='Five rounds is the practice';
        desc.textContent='Notice your shoulders. That drop is the parasympathetic response, the same one the Shift produces without you having to count.';
        go.textContent='Go again'; go.style.opacity='1'; running=false;
      });
    });
  }
  var mech=document.getElementById('mech'),
      sticky=document.getElementById('calm-sticky'),
      offer=document.getElementById('offer');
  if(mech && sticky && offer){
    window.addEventListener('scroll',function(){
      var past = window.scrollY > (mech.offsetTop + mech.offsetHeight*0.5);
      var atOffer = window.scrollY + window.innerHeight > offer.offsetTop + 200;
      sticky.classList.toggle('on', past && !atOffer);
    },{passive:true});
  }
  var TIERS = {
    starter: { items: [{ id: 63423109955953, quantity: 1 }], name: 'Micro-Calming Starter Kit', value: 79 },
    two:     { items: [{ id: 63423109955953, quantity: 2 }], name: 'Two-Person Kit', value: 158 }
  };
  function openCart(){
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getCart === 'function') { drawer.getCart(); return; }
    if (window.Rebuy && window.Rebuy.SmartCart) { window.Rebuy.SmartCart.show(); return; }
    var toggle = document.querySelector('[data-cart-toggle]');
    if (toggle) { toggle.click(); return; }
    document.dispatchEvent(new CustomEvent('theme:cart:change'));
    document.dispatchEvent(new CustomEvent('theme:product:added'));
    setTimeout(function(){ window.location.href = '/cart'; }, 800);
  }
  function setBusy(btn, busy){
    if(!btn) return;
    btn.disabled = !!busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    if(busy){ btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    else if(btn.dataset.label){ btn.textContent = btn.dataset.label; }
  }
  root.querySelectorAll('.calm-atc').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var tier = TIERS[btn.getAttribute('data-tier')];
      if(!tier) return;
      setBusy(btn, true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: tier.items })
      })
      .then(function(res){
        if(!res.ok) throw new Error('cart add failed '+res.status);
        return res.json();
      })
      .then(function(){
        setBusy(btn, false);
        if (typeof fbq === 'function') {
          fbq('track', 'AddToCart', {
            content_name: tier.name,
            content_category: 'calm',
            content_type: 'product',
            content_ids: tier.items.map(function(i){ return String(i.id); }),
            value: tier.value,
            currency: 'USD'
          });
        }
        openCart();
      })
      .catch(function(err){
        console.error('[calm-lp-v1 ATC]', err);
        setBusy(btn, false);
        alert("Couldn't add to cart — please try again.");
      });
    });
  });
})();
